<!--ESTA ES LA CABECERA REAL-->
<template>
  <nav class="" data-scroll="true">
    <div class="cabecera" id="navcabecera">
      <div class="left">
        <i
          v-if="$store.getters['auth/loggedIn']"
          class="fa me-xl-4 icono-lateral"
          :class="this.$store.state.mostrarMenuLateral ? 'fa-times' : 'fa-bars'"
          aria-hidden="true"
          @click="activarMenu"
        ></i>

        <router-link class="nav-link m-0 navbar-brand" :to="{ name: 'Profile' }">
          <img :src="logo" class="navbar-brand-img h-100" alt="Quanty" />
        </router-link>
      </div>

      <NavUserMenu />
    </div>
  </nav>
</template>

<script>
import logo from "@/assets/img/tipsterfy.png";
import NavUserMenu from "./NavUserMenu.vue";

export default {
  name: "NavCabecera",
  components: { NavUserMenu },

  data() {
    return { logo };
  },

  created() {
    if (window.innerWidth >= 1200) {
      // Desktop: sidebar empieza visible, icono ✕
      this.$store.state.mostrarMenuLateral = true;
    } else {
      // Móvil: sidebar empieza oculto, icono ☰
      this.$store.state.mostrarMenuLateral = false;
      document.getElementById("app").classList.remove("rtl");
    }
  },

  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      if (window.scrollY > 0 || window.innerWidth < 650) {
        document.body.classList.add("fijar-cabecera");
      } else {
        document.body.classList.remove("fijar-cabecera");
      }
    },

    activarMenu() {
      const nuevoEstado = !this.$store.state.mostrarMenuLateral;
      this.$store.state.mostrarMenuLateral = nuevoEstado;
      if (window.innerWidth >= 1200) {
        // Desktop: oculta/muestra completamente el sidebar
        this.$store.commit("setShowSidenav", nuevoEstado);
      } else {
        // Móvil: slide in/out via clase rtl
        if (nuevoEstado) {
          document.getElementById("app").classList.add("rtl");
        } else {
          document.getElementById("app").classList.remove("rtl");
        }
      }
    },
  },
};
</script>

<style>
.cabecera {
  height: 8vh;
  max-height: 80px;
  min-height: 45px;
  overflow: visible;
  border: 0;
  width: 100%;
  transition: all 0.3s ease;
  color: var(--q-text);
  background-color: var(--q-card);
  border-color: var(--q-border);

  & :hover { background-color: var(--q-hover) !important; }

  > .left,
  > .right {
    height: 100%;
    display: flex;
    align-items: center;
    float: left;
  }

  > .left > .navbar-brand {
    margin: 5px 12px !important;
    display: inline-block;
    height: calc(100% - 10px);
    padding: 0;
  }

  > .left > p {
    display: inline-block;
    font-size: 26px;
    margin: 0;
  }

  > .right {
    float: right;
    padding-right: 15px;
    gap: 10px;
  }

  > .right > a > i  { color: var(--q-text); margin-right: 10px !important; }
  > .right > a > span { color: var(--q-text); }

  .desconectar  { cursor: pointer; }
  .configuracion { padding: 0; margin: 0; width: 50px; text-align: center; }

  .estilo-trabajador {
    margin: 0 15px;
    font-weight: 600;
    transition: all 1s ease;
    white-space: nowrap;
  }
}

.fijar-cabecera .cabecera {
  transform: translateY(0);
  z-index: 999;
  position: fixed;
  top: 0;
  height: 3rem;

  .estilo-trabajador {
    margin: 0 5px;
    font-weight: 400;
    font-size: 0.85rem;
  }
}

@media (max-width: 650px) {
  .fijar-cabecera {
    .main-content { top: 60px; }
  }

  .cabecera .estilo-trabajador {
    max-width: 34vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 6px;
    font-size: 0.85rem;
  }

  .desconectar i {
    margin-right: 0 !important;
  }
}

.main-content {
  margin-top: 0.5rem;
  margin-bottom: 2.5rem;
}

.icono-lateral {
  font-size: 1.6rem;
  margin-left: 15px;
  cursor: pointer;
}

@media (min-width: 1200px) {
  .icono-lateral { display: none; }
}
</style>
